import {modify} from "mythil/object";
import { reduceResetPasswordLink, requestResetPasswordLink,  } from "./requestResetPasswordLink";
import { reduceUpdatePassword, updatePassword,} from "./updatePassword";

export const reducePassword = (state, action) => {
    state = modify(state ?? {}, 'updatePassword', (updatePassword) => reduceUpdatePassword(updatePassword, action));
    state = modify(state ?? {}, 'requestResetPasswordLink', (requestResetPasswordLink) => reduceResetPasswordLink(requestResetPasswordLink, action));
    return state;
}

export { requestResetPasswordLink, updatePassword};